import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewSummaryComponent } from './customer-review-summary.component';

runClientComponent({ customerReviewSummaryComponent: CustomerReviewSummaryComponent });
